import { render, staticRenderFns } from "./UserPaymentReports.vue?vue&type=template&id=85f05180&scoped=true&"
import script from "./UserPaymentReports.vue?vue&type=script&lang=js&"
export * from "./UserPaymentReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f05180",
  null
  
)

export default component.exports